module.exports = __webpack_public_path__ + "static/media/knife-thrust.1e29ef7c.svg";